import { getFaviconUrl } from '@app/src/pages/Questionnaire/Accessor/Report/AiScreening/favicon'
import type { SearchResult } from '@app/src/types/resourceExplorer'
import { Avatar, Link, Stack, Typography } from '@mui/material'
import React from 'react'
import TextTruncate from 'react-text-truncate'

interface AnswerSourcesListProps {
  searchResults: SearchResult[]
}

export const AnswerSourcesList: React.FC<AnswerSourcesListProps> = ({ searchResults }) => (
  <Stack spacing={3}>
    {searchResults.map((result, index) => (
      <Stack key={`${result.url}-${index}`} direction="row" spacing={1.25} alignItems="flex-start">
        <Avatar src={getFaviconUrl(result.url)} alt="" sx={{ width: 20, height: 20, mt: 0.25 }} />
        <Stack spacing={0.5} sx={{ minWidth: 0 }}>
          <Link variant="body1" color="text.secondary" href={result.url} target="_blank" rel="noopener">
            <TextTruncate text={result.url} line={1} />
          </Link>
          {result.title && (
            <Typography variant="body2" color="text.secondary">
              {result.title}
            </Typography>
          )}
          {result.date && (
            <Typography variant="body2" color="text.secondary">
              {result.date}
            </Typography>
          )}
        </Stack>
      </Stack>
    ))}
  </Stack>
)
